export default __webpack_public_path__ + "static/AC_Parallax_Still-781a201abdac67cb33fc8cbb5c213be1.jpg";